import {
    BOOKING_LIST_GET_LIST,
    BOOKING_LIST_GET_LIST_SUCCESS,
    BOOKING_LIST_GET_LIST_ERROR,
    BOOKING_LIST_GET_LIST_WITH_FILTER,  
} from '../actions';


export const getBookingList = () => ({
    type: BOOKING_LIST_GET_LIST
});

export const getBookingListSuccess = (bookings) => ({
    type: BOOKING_LIST_GET_LIST_SUCCESS,
    payload: {bookings}
});

export const getBookingListError = (error) => ({
    type: BOOKING_LIST_GET_LIST_ERROR,
    payload: error
});

export const getBookingListWithFilter = (column, value) => ({
    type: BOOKING_LIST_GET_LIST_WITH_FILTER,
    payload: { column, value }
});

export const getBookingListSearch = (startDate,endDate,hotel) => ({
    type: BOOKING_LIST_GET_LIST_WITH_FILTER,
    payload: {startDate,endDate,hotel}
});